import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'
import Step from './DashboardBuilderStep'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import { useAct } from 'DashboardBuilder/store'

function InstructionsShortDescriptor({ complete, instructions }) {
  return <div>
    {complete && <div dangerouslySetInnerHTML={{ __html: instructions }} />}
    {!complete && <p className='incomplete no-margin-bottom'>Describe and set up instructions for your dashboard.</p>}
  </div>
}

export default function Instructions() {
  const act = useAct()
  const { instructions } = useSel((s) => s.dashboard)
  const complete = !!instructions && instructions != '<p></p>' // default empty string given by editor
  const { mergeTags } = useSel(s => s.builder)

  function onChange(html) {
    act.dashboard.upsert({ instructions: html })
  }

  function save() {
    return act.builder.save('instructions').then(() => {
      act.builder.closeEditor()
    })
  }

  return <Step
    name='Instructions'
    editor='instructions'
    complete={complete}
    canClickFinish={complete}
    save={save}
    shortDescriptor={<InstructionsShortDescriptor complete={complete} instructions={instructions} />}
  >
    <InlineCkEditor
      value={instructions}
      onUpdate={onChange}
      hideMergeTags={true}
      features={[]}
    />
    <LiquidValidator value={instructions} lineSplitTags={true} availableTags={mergeTags} />
  </Step>
}
